import styled from '@emotion/styled';
import { keyframes, css } from 'emotion';

import CircleDotsIcon from './assets/CircleDots.png';
import CircleFillIcon from './assets/CircleFill.png';
import CircleStrokeIcon from './assets/CircleStroke.png';
import SquareIcon from './assets/Square.png';
import xIcon from './assets/X.png';
import { getRandomInRange } from './util';

const ANIMATION_DURATION = '2800'; // ms

const confettiKeyframes = keyframes`
  0%, 30% {
    opacity: 0;
  }
  50% {
    opacity: 0.8;
  }
  100% {
    opacity: 0;
    transform: translate(-50%, 1000%) rotate(340deg);
  }
`;

const starKeyframeStart = `
  0% {
    opacity: 0;
    transform: scale(0) translate(-50%, -50%) rotate(0deg);
  }
`;

const star1Keyframe = keyframes`
  ${starKeyframeStart}
  5% {
    opacity: 0.7;
  }
  10% {
    opacity: 1;
  }
  30% {
    opacity: 1;
    transform: scale(0.8) translate(400%, -320%) rotate(65deg);
  }
  100% {
    opacity: 0;
    transform: scale(0.8) translate(400%, -120%) rotate(210deg);
  }
`;

const star2Keyframe = keyframes`
  ${starKeyframeStart}
  5% {
    opacity: 1;
  }
  20% {
    opacity: 1;
    transform: scale(1.1) translate(280%, -30%) rotate(115deg);
  }
  100% {
    opacity: 0;
    transform: scale(1.1) translate(280%, 270%) rotate(300deg);
  }
`;

const star3Keyframe = keyframes`
  ${starKeyframeStart}
  5% {
    opacity: 1;
  }
  20% {
    opacity: 1;
    transform: scale(0.8) translate(450%, 250%) rotate(35deg);
  }
  100% {
    opacity: 0;
    transform: scale(0.8) translate(450%, 550%) rotate(240deg);
  }
`;

const star4Keyframe = keyframes`
  ${starKeyframeStart}
  5% {
    opacity: 1;
  }
  20% {
    opacity: 1;
    transform: scale(1) translate(-400%, -180%) rotate(90deg);
  }
  100% {
    opacity: 0;
    transform: scale(1) translate(-400%, 120%) rotate(280deg);
  }
`;

const star5Keyframe = keyframes`
  ${starKeyframeStart}
  5% {
    opacity: 1;
  }
  20% {
    opacity: 1;
    transform: scale(0.8) translate(-460%, 70%) rotate(175deg);
  }
  100% {
    opacity: 0;
    transform: scale(0.8) translate(-460%, 370%) rotate(360deg);
  }
`;

const star1 = css`
  animation: ${star1Keyframe} ${ANIMATION_DURATION}ms forwards ease-in-out;
`;

const star2 = css`
  animation: ${star2Keyframe} ${ANIMATION_DURATION}ms forwards ease-in-out;
`;

const star3 = css`
  animation: ${star3Keyframe} ${ANIMATION_DURATION}ms forwards ease-in-out;
`;

const star4 = css`
  animation: ${star4Keyframe} ${ANIMATION_DURATION}ms forwards ease-in-out;
`;

const star5 = css`
  animation: ${star5Keyframe} ${ANIMATION_DURATION}ms forwards ease-in-out;
`;

export const STARS = [
  star1,
  star2,
  star3,
  star4,
  star5,
];

const generateConfettiClassName = () => css`
  transform: rotate(${getRandomInRange(0, 360)}deg) translate(-50%, -50%);
`;

export const CONFETTI = [
  {
    icon: CircleDotsIcon,
    className: generateConfettiClassName(),
  },
  {
    icon: CircleFillIcon,
    className: generateConfettiClassName(),
  },
  {
    icon: CircleStrokeIcon,
    className: generateConfettiClassName(),
  },
  {
    icon: SquareIcon,
    className: generateConfettiClassName(),
  },
  {
    icon: xIcon,
    className: generateConfettiClassName(),
  },
];

export const starClassName = css`
  position: absolute;
  top: 30%;
  left: 50%;
  transform: scale(0) translate(-50%, -50%);
  opacity: 0;
  width: 30px;
  height: 30px;
`;

export const confettiAnimation = css`
  animation: ${confettiKeyframes} ${ANIMATION_DURATION}ms forwards ease-in;
`;

export const Container = styled.div`
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  overflow: hidden;
  z-index: 1;
  user-select: none;
  pointer-events: none;

  img {
    position: absolute;
    opacity: 0;
  }
`;
